var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.accessMode === 2)?_c('dingApprovalDetail'):_vm._e(),_vm._v(" "),(_vm.accessMode === 1)?[(_vm.type === 'approval')?_c('collectionDetails',{attrs:{"params":_vm.params}}):_vm._e(),_vm._v(" "),(_vm.type === 'widthhold')?_c('withhold',{attrs:{"params":_vm.params}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }